module.exports = __webpack_public_path__ + "01_bob_yellow.b23a4d1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/01_bob_yellow.png
// module id = BoUw
// module chunks = 0